<template>
  <div class="InitiateInterview">
    <new-head title="发起面试"> </new-head>
    <div class="content">
      <div class="item">
        <p>应聘者姓名:</p>
        <span>{{ resumeDetails.applicant_name }}</span>
      </div>

      <div class="item">
        <p>应聘部门:</p>
        <span>{{ resumeDetails.applicant_section }}</span>
      </div>

      <div class="item">
        <p>应聘岗位:</p>
        <span>{{ resumeDetails.position_applied }}</span>
      </div>

      <div class="item">
        <p>附件:</p>
        <span>
          <a href="">{{ resumeDetails.accessory_url }}</a>
        </span>
      </div>

      <div class="item">
        <p>任务时间:</p>
        <div>
          <div class="timeIpt" @click="openTimePicker(1)">
            <span v-if="form.interview_start_time">{{ form.interview_start_time }}</span>
            <span v-else>请选择</span>
          </div>
          <span>至</span>
          <div class="timeIpt" @click="openTimePicker(2)">
            <span v-if="form.interview_end_time">{{ form.interview_end_time }}</span>
            <span v-else>请选择</span>
          </div>
        </div>
      </div>

      <p>面试官（每人奖励100元）</p>
      <el-table :data="tableData" border style="width: 100%" class="table">
        <el-table-column type="index" width="50" label="序号"> </el-table-column>
        <el-table-column prop="realname" label="姓名" width="80"> </el-table-column>
        <el-table-column prop="account" label="工号" width="90"> </el-table-column>
        <el-table-column prop="address" label="是否有奖金">
          <template slot-scope="scope">
            <van-radio-group v-model="scope.row.is_bonus" direction="horizontal">
              <van-radio name="1">有奖金</van-radio>
              <van-radio name="2">无奖金</van-radio>
            </van-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="add flex-center" @click="addShow = true">+新增人员</div>

      <button class="save" @click="save">发布</button>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="timeConfirm"
        @cancel="show = false"
      />
    </van-popup>
    <van-popup v-model="addShow" position="center" @close="popupClose">
      <div class="addFormBox">
        <h5>新增面试官</h5>
        <el-form label-width="50px" class="addForm">
          <el-form-item label="姓名">
            <el-input
              placeholder="请输入姓名"
              v-model="searchName"
              @input="search"
            ></el-input>
          </el-form-item>
          <el-form-item label="工号">
            <el-select
              v-model="user"
              value-key="uid"
              placeholder="请选择"
              style="z-index: 3000"
            >
              <el-option
                v-for="item in JobNumberList"
                :label="item.realname + item.account"
                :value="item"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="bottom">
          <button @click="addShow = false">取消</button>
          <button class="addUserSubmit" @click="addUserSubmit">确认</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  searchJobNumberApi,
  resumeTaskDetailsApi,
  issueInterviewApi,
} from "@/api/api/resume";
import { Toast } from "vant";
export default {
  data() {
    return {
      task_id: null,

      resumeDetails: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      timeType: null,
      currentDate: new Date(),
      show: false,

      form: {
        interview_start_time: "",
        interview_end_time: "",
      },
      tableData: [],
      addShow: false,
      searchName: "",
      user: null,
      JobNumberList: [],
    };
  },
  created() {
    this.task_id = this.$route.query.task_id;

    this.getData();
  },
  methods: {
    async getData() {
      let res = await resumeTaskDetailsApi(this.task_id);
      this.resumeDetails = res.data.data.resumeDetails;
    },
    openTimePicker(i) {
      this.timeType = i;
      this.show = true;
    },
    timeConfirm() {
      this.show = false;
      if (this.timeType == 1) {
        this.form.interview_start_time = this.timeFormat(this.currentDate);
      } else if (this.timeType == 2) {
        this.form.interview_end_time = this.timeFormat(this.currentDate);
      }
    },
    async search() {
      if (!this.searchName) {
        return;
      }
      let res = await searchJobNumberApi(this.searchName);
      console.log(res);
      this.JobNumberList = res.data.data;
    },
    addUserSubmit() {
      if (!this.user) {
        return Toast("请选择人员");
      }
      console.log(this.user);
      let flag = false;
      this.tableData.forEach((item) => {
        if (item.uid == this.user.uid) {
          flag = true;
        }
      });
      if (flag) {
        return Toast("重复添加");
      }
      let item = {
        ...this.user,
        is_bonus: "2",
      };
      this.tableData.push(item);
      this.addShow = false;
    },
    async save() {
      let { interview_start_time, interview_end_time } = this.form;
      if (!interview_start_time || !interview_end_time) {
        return Toast("请选择面试时间");
      }
      if (!this.tableData.length) {
        return Toast("请选择面试官");
      }
      let params = {
        task_id: this.task_id,
        ...this.form,
        screen_job_number_list: this.tableData.map((item) => {
          return {
            uid: item.uid,
            is_bonus: item.is_bonus,
          };
        }),
      };
      console.log(params);
      let res = await issueInterviewApi(params);
      console.log(res);
      if (res.data.httpCode == 200) {
        Toast("发布成功");
        this.$router.back();
      }
    },
    popupClose() {
      this.searchName = "";
      this.user = "";
      this.JobNumberList = [];
    },
  },
};
</script>

<style lang="scss">
.content {
  padding: 30px 15px;

  .item {
    display: flex;
    margin-bottom: 20px;
    font-size: 14px;
    color: #868686;

    p {
      width: 80px;
      text-align: right;
      margin-right: 10px;
    }

    > span {
      flex: 1;
      border-bottom: 1px solid #000;

      a {
        color: #33a6ff;
        word-break: break-all;
      }
    }

    > div {
      flex: 1;
      display: flex;
      justify-content: center;

      > span {
        margin: 0 25px;
        color: #000;
      }
    }
  }

  .datetimePicker {
    width: 100%;
    background-color: pink;
  }

  .table {
    margin-top: 20px;
  }

  .add {
    width: 100%;
    height: 30px;
    border: 1px solid #8a8a8a;
    border-top: none;
  }

  .save {
    width: 100%;
    height: 40px;
    border-radius: 20px;
    background-color: #0286ff;
    color: #fff;
    margin-top: 20px;
  }
}

.van-popup {
  background: none;
}

.addFormBox {
  width: 300px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;

  h5 {
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
  }

  .addForm {
    padding: 20px;
    padding-bottom: none;
  }

  .bottom {
    width: 100%;
    display: flex;

    button {
      flex: 1;
      height: 40px;
      background: #e9f2ff;
      color: #0286ff;
    }

    .addUserSubmit {
      background: #0286ff;
      color: #fff;
    }
  }
}
</style>
